var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,1 L14,12 L4,12 C3.44771525,12 3,12.4477153 3,13 C3,13.5522847 3.44771525,14 4,14 L4,14 L14,14 L14,15 L4,15 C3.46958283,15 2.96087485,14.7786877 2.58582422,14.3848846 C2.21074988,13.9910723 2,13.4569458 2,12.9 L2,2.4 C2,2.02865128 2.14046173,1.67261239 2.39060348,1.41013366 C2.64063675,1.14759953 2.97973344,1 3.33333333,1 L14,1 Z M13,2 L3,2 L3,11 L13,11 L13,2 Z M8.72,3.77407407 L8.72,5.666 L10.6666667,5.66666667 L10.6666667,7.06666667 L8.72,7.066 L8.72,8.95925926 L7.28,8.95925926 L7.28,7.066 L5.33333333,7.06666667 L5.33333333,5.66666667 L7.28,5.666 L7.28,3.77407407 L8.72,3.77407407 Z",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.0aad203c88b8cb8a1c96e79c56840e09.svg";
export { ForwardRef as ReactComponent };